var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Global-Notification/Success",
    transform: "translate(-12.000000, -11.000000)",
    fill: "#72BF44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.602525,7.06125 L8.249775,12.273 L4.499775,8.52375 L5.561025,7.4625 L8.249775,10.15125 L12.541275,6 L13.602525,7.06125 Z M-0.000225,9 C-0.000225,13.97025 4.029525,18 8.999775,18 C13.970775,18 17.999775,13.97025 17.999775,9 C17.999775,4.02975 13.970775,0 8.999775,0 C4.029525,0 -0.000225,4.02975 -0.000225,9 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/checkCircleGreen.0144d1ec98b14456622a045f2bc4c53c.svg";
export { ForwardRef as ReactComponent };